import metrics from './skierSpriteMetrics.json';

export type SkierPose = keyof typeof metrics;
export const HELMET_DRAW_WIDTH = 17.5;

// Alpha bounds were measured at alpha >= 16. Helmet widths and boot/ski
// contact centers are source-pixel landmarks; see the visual review sheet.
// A shared helmet scale preserves posture changes without stretching sprites.
export function skierSpriteRect(pose: SkierPose, contactY = 22) {
  const { bounds, helmetWidth, contact } = metrics[pose];
  const scale = HELMET_DRAW_WIDTH / helmetWidth;
  return {
    sx: bounds[0], sy: bounds[1], sw: bounds[2], sh: bounds[3],
    dx: (bounds[0] - contact[0]) * scale,
    dy: contactY + (bounds[1] - contact[1]) * scale,
    dw: bounds[2] * scale, dh: bounds[3] * scale,
  };
}

// Cache at render resolution, not full asset resolution. No per-frame tinting or pixel reads.
const tintedSprites = new WeakMap<HTMLImageElement, Map<string, HTMLCanvasElement>>();
export function drawSkierSprite(ctx: CanvasRenderingContext2D, image: HTMLImageElement, pose: SkierPose, contactY = 22, tint?: string) {
  if (!image.complete || image.naturalWidth === 0) return;
  const r = skierSpriteRect(pose, contactY);
  if (!tint) { ctx.drawImage(image, r.sx, r.sy, r.sw, r.sh, r.dx, r.dy, r.dw, r.dh); return; }
  let cache = tintedSprites.get(image);
  if (!cache) { cache = new Map(); tintedSprites.set(image, cache); }
  const key = `${pose}:${tint}`;
  let sprite = cache.get(key);
  if (!sprite) {
    sprite = document.createElement('canvas');
    sprite.width = Math.ceil(r.dw * 3); sprite.height = Math.ceil(r.dh * 3);
    const paint = sprite.getContext('2d');
    if (!paint) { ctx.drawImage(image, r.sx, r.sy, r.sw, r.sh, r.dx, r.dy, r.dw, r.dh); return; }
    paint.drawImage(image, r.sx, r.sy, r.sw, r.sh, 0, 0, sprite.width, sprite.height);
    paint.globalCompositeOperation = 'source-atop';
    paint.globalAlpha = 0.28;
    paint.fillStyle = tint; paint.fillRect(0, 0, sprite.width, sprite.height);
    cache.set(key, sprite);
  }
  ctx.drawImage(sprite, r.dx, r.dy, r.dw, r.dh);
}
